<div [id]="containerId" class="stadium-camera-360-container"></div>
<!-- TODO: Replace with Angular 18 compatible context menu -->
<!-- <context-menu *ngIf="isAdmin">
    <ng-template contextMenuItem [enabled]="contextMenuCanEdit" (execute)="onSelectCamera.emit($event.item)">
        Edit
    </ng-template>
    <ng-template contextMenuItem (execute)="contextMenuDelete($event.item)">
        Delete
    </ng-template>
</context-menu> -->